module.exports = __webpack_public_path__ + "static/media/team-05.dd22906b.jpg";